import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PlugZap, ArrowRight, Wifi, Sparkles } from "lucide-react";

const AegHighlight = () => {
  return (
    <section className="py-14 lg:py-16 bg-white" data-testid="aeg-highlight">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.55 }}
          className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-navy-900 via-navy-900 to-brand/70 text-white p-8 lg:p-14"
        >
          <div className="blob-pink absolute -top-24 -left-24 opacity-40" />
          <div className="blob-pink absolute -bottom-24 -right-24 opacity-30" />

          <div className="relative grid lg:grid-cols-[1.3fr_1fr] gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 backdrop-blur text-[11px] font-bold uppercase tracking-widest">
                <PlugZap size={13} /> Nieuw · Plug & Play
              </span>
              <h2 className="mt-4 font-heading text-4xl md:text-5xl font-black tracking-tighter leading-tight text-balance">
                AEG Thuisbatterij die u <span className="gradient-pink-text">zelf installeert</span>.
              </h2>
              <p className="mt-5 text-slate-200 text-lg leading-relaxed max-w-xl">
                4,8 kWh opslag, aansluiten op een standaard stopcontact, slim gestuurd via de app. Ideaal voor huishoudens die profiteren willen van dynamische tarieven of hun zonne-energie zonder verbouwing.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link to="/aeg-plug-play" className="btn-pink !text-white" data-testid="aeg-highlight-cta">
                  Bekijk AEG Plug & Play <ArrowRight size={16} />
                </Link>
                <Link to="/aeg-plug-play#offerte" className="btn-ghost !bg-white/10 !text-white !border-white/20 hover:!bg-white/20">
                  Vraag offerte aan
                </Link>
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-300">
                <span className="inline-flex items-center gap-2"><Sparkles size={14} className="text-brand" /> Vanaf € 1.499</span>
                <span className="inline-flex items-center gap-2"><Wifi size={14} className="text-brand" /> Wifi + P1-meter</span>
                <span className="inline-flex items-center gap-2"><PlugZap size={14} className="text-brand" /> Geen elektricien nodig</span>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-square rounded-3xl bg-white/5 border border-white/10 backdrop-blur flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="absolute w-48 h-48 rounded-full bg-brand/40 blur-3xl" />
                  <img src="/images/batteries/aeg-plug-play-dark.png" alt="AEG Plug & Play 4,8 kWh" loading="lazy" className="relative w-full h-full object-cover" />
                </div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-xs z-10">
                  <span className="px-2.5 py-1 rounded-full bg-white/95 text-navy-900 font-bold">4,8 kWh</span>
                  <span className="px-2.5 py-1 rounded-full bg-white/95 text-navy-900 font-bold">Plug & Play</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AegHighlight;
